// We want to patch element-ui's dependency to async-validator. Therefore,
// we don't include it in our own dependency list to make sure we patch
// the same AsyncValidator instance.
// eslint-disable-next-line import/no-extraneous-dependencies
import AsyncValidator from 'async-validator';
import i18next from 'i18next';

const messageCache = {};

function getMessages() {
  const { language } = i18next;

  if (!messageCache[language]) {
    const t = i18next.getFixedT(language);

    messageCache[language] = {
      default: t('asyncValidator.default'),
      required: t('asyncValidator.required'),
      enum: t('asyncValidator.enum'),
      whitespace: t('asyncValidator.whitespace'),
      date: {
        format: t('asyncValidator.date.format'),
        parse: t('asyncValidator.date.parse'),
        invalid: t('asyncValidator.date.invalid'),
      },
      types: {
        string: t('asyncValidator.types.string'),
        method: t('asyncValidator.types.method'),
        array: t('asyncValidator.types.array'),
        object: t('asyncValidator.types.object'),
        number: t('asyncValidator.types.number'),
        date: t('asyncValidator.types.date'),
        boolean: t('asyncValidator.types.boolean'),
        integer: t('asyncValidator.types.integer'),
        float: t('asyncValidator.types.float'),
        regexp: t('asyncValidator.types.regexp'),
        email: t('asyncValidator.types.email'),
        url: t('asyncValidator.types.url'),
        hex: t('asyncValidator.types.hex'),
      },
      string: {
        len: t('asyncValidator.string.len'),
        min: t('asyncValidator.string.min'),
        max: t('asyncValidator.string.max'),
        range: t('asyncValidator.string.range'),
      },
      number: {
        len: t('asyncValidator.number'),
        min: t('asyncValidator.number'),
        max: t('asyncValidator.number'),
        range: t('asyncValidator.number.range'),
      },
      array: {
        len: t('asyncValidator.array.len'),
        min: t('asyncValidator.array.min'),
        max: t('asyncValidator.array.max'),
        range: t('asyncValidator.array.range'),
      },
      pattern: {
        mismatch: t('asyncValidator.pattern.mismatch'),
      },
    };
  }

  return messageCache[language];
}

// eslint-disable-next-line import/prefer-default-export
export function patchAsyncValidatorMessages() {
  AsyncValidator.prototype.messages = getMessages;
}
